<template>
  <div>
    <terms-and-conditon :isPromptActive="termsPrompt" @closePrompt="toggleTermsPrompt" />
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <vx-card>
          <div slot="no-body" class="full-page-bg-color">

            <div class="vx-row no-gutter justify-center items-center">

              <div class="vx-col hidden lg:block lg:w-1/2">
                <!--
                                <img style="max-width: 400px; width: 400px; height: 230px; max-height: 230px" src="@/assets/images/landing.jpeg" alt="login" class="mx-auto">
                -->
                <img style="max-width: 400px; width: 400px; height: 230px; max-height: 230px"
                  src="@/assets/images/landing_mtn.jpg" alt="login" class="mx-auto">
              </div>

              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div class="p-8 login-tabs-container">

                  <div class="vx-card__title mb-4">
                    <h4 class="mb-4">Connexion</h4>
                    <p>Ouvrez une session pour commencer à utiliser l'application.</p>
                  </div>

                  <div>
                    <vs-input autocomplete="off" :danger="error.phone ? true : false"
                      :danger-text="error.phone ? error.phone[0] : ''" class="w-full" v-model="form.phone"
                      label-placeholder="Identifiant" name="phone" icon-no-border icon="icon icon-user"
                      icon-pack="feather" @keyup.enter="loginPhone()" />
                    <vs-input autocomplete="off" :danger="error.password ? true : false"
                      :danger-text="error.password ? error.password[0] : ''" class="w-full mt-6" v-model="form.password"
                      type="password" name="password" icon-no-border icon="icon icon-lock" icon-pack="feather"
                      label-placeholder="Mot de passe" @keyup.enter="loginPhone()" />
                    <div class="flex flex-wrap mt-4">
                      <vs-checkbox v-model="accept_terms_and_condition" class="mb-3">J'accepte la</vs-checkbox>
                      <span v-on:click="termsPrompt = true">
                        <a style="color: black; cursor: pointer; text-decoration: underline;">politique de
                          confidentialité</a>
                      </span>
                    </div>
                    <!-- <vue-recaptcha ref="recaptcha" :sitekey="captcha_site_key" :loadRecaptchaScript="true"
                      @verify="onCaptchaVerified" @expired="onCaptchaExpired">
                    </vue-recaptcha> -->
                    <small class="text-danger" v-if="!!error.recaptcha">{{ error.recaptcha ? error.recaptcha[0] : '' }}</small>
                    <div class="mt-8">
                      <router-link to="/password-reset">Mot de passe oublié?</router-link>
                      <vs-button class="float-right mb-8" @click="loginPhone()">Connexion</vs-button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <!--<p style="margin-top: -100px" class="flex w-full vx-row items-center justify-center">
      Copyright &copy; Togocel Designed By
      <a target="_blank" style="margin-left: 5px !important;" href="http://ebusinessafrique.com">e-Business Afrique</a>
    </p>-->
    <p style="margin-top: -100px" class="flex w-full vx-row items-center justify-center">
      Copyright &copy; MTN Designed By
      <a target="_blank" style="margin-left: 5px !important; color: black" href="http://ebusinessafrique.com">e-Business
        Afrique</a>
    </p>
  </div>
</template>

<script>
import termsAndConditon from "./termsAndCondition.vue";
import { VueRecaptcha } from 'vue-recaptcha';

let base_self;

export default {
  components: { termsAndConditon, VueRecaptcha },
  data: () => ({
    error: [],
    form: {
      phone: '',
      password: '',
      recaptcha: ''
    }, //
    accept_terms_and_condition: false,
    termsPrompt: false,
    captcha_site_key: "6Lc_foAkAAAAABkI6xlSuoOUN7LwjdXTISDFFgtw",
    validateCaptcha: false
  }),
  computed: {

  },
  methods: {
    toggleTermsPrompt(val = false) {
      this.termsPrompt = val;
    },
    async loginPhone() {
      if (!this.accept_terms_and_condition) {
        window.GETCCMT.error({ message: "Vous n'avez pas acceptez la politique de confidentialité" });
      } else {
        base_self.$vs.loading()
        window.GETCCMT.$http.post('/login', base_self.form)
          .then((response) => {
            if (response.data.status) {
              base_self.error = []
              // this.onCaptchaExpired()
              if (response.data.auth === 'OTP') {
                window.LoginCCMT.phone = response.data.phone;
                window.LoginCCMT.phone_see = !window.LoginCCMT.phone_see;
                window.LoginCCMT.sms = !window.LoginCCMT.sms;
                window.LoginCCMT.code = response.data.code;
                window.GETCCMT.success('Connexion avec succès', response);
                localStorage.setItem('accept_terms_and_condition', this.accept_terms_and_condition)
                base_self.$vs.loading.close()
              } else {
                response.data.user.displayName = response.data.user.name;
                response.data.user.userRole = response.data.user.profile;
                response.data.user.company = response.data.user.customer;
                response.data.user.photoURL = response.data.user.photo;
                base_self.$store.dispatch('updateUserInfo', response.data.user);
                localStorage.setItem('accept_terms_and_condition', this.accept_terms_and_condition)
                base_self.$vs.loading.close()
                base_self.$router.push('/dashboard');
              }
            }
          }).catch((error) => {
            base_self.$vs.loading.close()
            if (error.response.status === 401) {
              window.GETCCMT.$router.push('/login')
            } else {
              base_self.error = error.response.data.errors
            }
          });
      }
    },
    onCaptchaVerified(recaptchaToken) {
      this.form.recaptcha = recaptchaToken
      this.validateCaptcha = true
    },
    onCaptchaExpired() {
      this.form.recaptcha = "";
      this.$refs.recaptcha.reset();
    },
  },
  async created() {
    base_self = this;
    let has_accept_terms = localStorage.getItem("accept_terms_and_condition");
    this.accept_terms_and_condition = has_accept_terms;
  }
}
</script>
